@use '../colors.scss' as colors;

.alert {
  margin-top: 15px;
  margin-bottom: 15px;
  position: relative;
}

.error {
  & > div {
    width: 100%;
    text-align: center;
  }

  i {
    float: left;
    margin-right: 5px;
  }
}

:global(.flexpay) {
  .alert:global(.notice) {
    color: colors.$flexpay-body-text;
    border: 1.5px solid colors.$flexpay-link;
    background: #fff;
    border-radius: 4px;
    padding: 16px;
    font-size: 13px;
    margin-bottom: 30px;
    text-align: left;

    strong {
      color: colors.$flexpay-title;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
  }
}
